import { __decorate, __metadata, __param } from "tslib";
import { Directive, Inject, Input } from 'angular-ts-decorators';
var SupportVideoDirective = (function () {
    function SupportVideoDirective($element, videoService, eventHelper, siteLanguage) {
        this.$element = $element;
        this.videoService = videoService;
        this.eventHelper = eventHelper;
        this.siteLanguage = siteLanguage;
        this.videoId = '';
    }
    SupportVideoDirective.prototype.ngOnChanges = function (onChangesObject) {
        var _this = this;
        if (!onChangesObject.videoId) {
            return;
        }
        if (!this.videoId) {
            this.$element.html('');
            return;
        }
        var timestamp = new Date().getTime();
        var videoElementId = this.videoId + "__" + timestamp;
        this.$element.append("<div id=\"" + videoElementId + "\"></div>");
        this.videoService
            .provider()
            .then(function (provider) {
            provider.create(_this.videoId, videoElementId, {
                allowFullscreen: _this.allowFullscreen,
                autoPlay: _this.autoPlay,
                interfaceLanguage: _this.siteLanguage,
                lazy: _this.lazy,
            });
            _this.eventHelper.setLazy(_this.$element).triggerScroll();
        });
    };
    SupportVideoDirective.$inject = [];
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SupportVideoDirective.prototype, "allowFullscreen", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SupportVideoDirective.prototype, "autoPlay", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], SupportVideoDirective.prototype, "lazy", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", Object)
    ], SupportVideoDirective.prototype, "videoId", void 0);
    SupportVideoDirective = __decorate([
        Directive({
            restrict: 'E',
            selector: 'supportVideo',
        }),
        __param(0, Inject('$element')),
        __param(1, Inject('videoService')),
        __param(2, Inject('eventHelper')),
        __param(3, Inject('siteLanguage')),
        __metadata("design:paramtypes", [Object, Object, Object, String])
    ], SupportVideoDirective);
    return SupportVideoDirective;
}());
export { SupportVideoDirective };
